export { default } from './DocumentHtml';
export type { DocumentHtmlProps } from './DocumentHtml';
